const projectSliderTools = {
    init() {
        $('.js_project-slider__slider').each((i, el) => {
            const delay = 2;
            const items = $(el).find('.js_project-slider__item')
            const wrapper = $(el).find('.js_project-slider__wrapper')
            if (items.length < 4) {
                let counter = Math.ceil(4 / items.length)
                for (let i = 0; i < counter; i++) {
                    const clones = items.clone().addClass('clone')
                    wrapper.append(clones)
                }
            }
            $(el).find('.js_project-slider__item').clone().addClass('clone').appendTo(wrapper)
            const newLength = $(el).find('.js_project-slider__item').length
            $(el).css('--delay', `${newLength * delay}s`)
        })
    },
}

$(document).ready(() => {
    projectSliderTools.init()
})